import React from 'react'
import PropTypes from 'prop-types'

import { Dai } from 'components'

const DaiGovernanceBanner = ({ onOpenChat }) => (
  <Dai.Banner
    animated
    message="Precisa de ajuda com este controle? A DAI pode te orientar."
    action={
      <Dai.StarButton variant="outlined" size="small" onClick={onOpenChat}>
        Novo Chat
      </Dai.StarButton>
    }
  />
)

DaiGovernanceBanner.propTypes = {
  onOpenChat: PropTypes.func.isRequired,
}

export default DaiGovernanceBanner
